module.exports = __webpack_public_path__ + "img/awards-badges.6b0c9463.png";